import axios from '../http/index'
function setInfo(state) {
    if (Object.keys(state.info).length == 0) {
        let data = JSON.parse(localStorage.getItem("user_info"))
        data.list = undefined
        data.mob = localStorage.getItem("mob")
        state.info = data;
    }
}
const my = {
    namespaced: true,
    state: () => {
        return {
            info: {}
        }
    },
    getters: {
        user_info(state) {
            setInfo(state)
            return state.info
        }
    },
    mutations: {
        setInfo(state) {
            setInfo(state)
        },
        upInfo(state) {

        }
    },
    actions: {
        saveUserInfo(context, res) {
            //             postgraduate_id	考研院校
            // postgraduate_name	考研院校
            // postgraduate_major_id	考研专业
            // postgraduate_major_name	考研专业
            // colleges_id	本科院校
            // colleges_name	本科院校
            // major_id	本科专业
            // major_name	本科专业
            // work_unit_hospital	工作地
            // education	学历
            // hospital	医院
            // test_time	考试时间
            // work_time	工作时间
            // is_official	是否为官方账号（1:是 0:否）
            // is_edit	是否可以编辑昵称 0:是 1：否;

            setInfo(context.state)
            for (let e of Object.keys(res)) {
                context.state.info[e] = res[e]
            }

            let keys = ['postgraduate_id', 'postgraduate_name',
                'postgraduate_major_id', 'postgraduate_major_name',
                'colleges_id', 'colleges_name', 'major_id',
                'major_name', 'work_unit_hospital',
                'education', 'hospital', 'test_time', 'work_time', 'is_official', 'is_edit', 'nickname', 'avatar', 'sex', 'mob']
            let data = {};
            for (let key of keys) {
                data[key] = context.state.info[key]
            }

            axios.post("userApi/index.php/user/StartUp/onlineEdit", data).then(res => {
                localStorage.setItem("user_info", JSON.stringify(context.state.info))
            })
        }
    }
}
export default my


// WEBPACK FOOTER //
// ./src/store/my.js